import productSuggest from 'components/product/product-suggest.vue';

Vue.component('product-suggest', productSuggest);

const carousel = document.querySelectorAll('.algolia-carousel');
carousel.forEach((carousel) => {
    new Vue({
        el: carousel,
    });
});